import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mapAlt"
const MapAltIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.25 13.125C18.078 13.125 18.75 13.797 18.75 14.625S18.078 16.125 17.25 16.125 15.75 15.453 15.75 14.625 16.422 13.125 17.25 13.125" />
          <path
            fillRule="evenodd"
            d="M17.25 9.375C18.72 9.375 20.047 9.909 21 10.845L21.027 10.873Q21.092 10.938 21.155 11.005L21.232 11.09 21.316 11.187Q21.35 11.228 21.383 11.271 21.428 11.326 21.472 11.383L21.522 11.453Q21.573 11.522 21.62 11.59L21.666 11.663Q21.709 11.724 21.746 11.788 21.778 11.84 21.808 11.894L21.878 12.016 21.907 12.078Q21.951 12.158 21.991 12.242L22.014 12.293Q22.162 12.614 22.267 12.965 22.413 13.45 22.467 13.989 22.499 14.288 22.5 14.6 22.5 14.736 22.491 14.873 22.491 14.897 22.488 14.92 22.48 15.055 22.465 15.188L22.46 15.223Q22.451 15.309 22.437 15.395 22.421 15.506 22.4 15.617L22.378 15.731Q22.356 15.836 22.33 15.941 22.315 16.013 22.296 16.085 22.274 16.169 22.25 16.254 22.152 16.589 22.026 16.92 22.003 16.984 21.98 17.046L21.9 17.236 21.843 17.368Q21.798 17.47 21.75 17.574L21.71 17.658C20.408 20.379 17.89 22.675 17.25 22.675 16.375 22.675 12 18.4 12 14.6 12 12.49 13.056 10.863 14.625 10.018L14.645 10.008Q14.966 9.837 15.309 9.711L15.382 9.686Q15.44 9.665 15.499 9.646L15.614 9.61 15.714 9.58 15.84 9.549Q15.942 9.522 16.047 9.5L16.125 9.483Q16.669 9.376 17.25 9.375M17.25 10.875C15.122 10.875 13.5 12.337 13.5 14.6 13.5 15.994 14.342 17.681 15.48 19.14 16.026 19.842 16.589 20.422 17.04 20.812Q17.155 20.909 17.25 20.984 17.346 20.909 17.46 20.812C17.91 20.422 18.472 19.842 19.02 19.14 20.157 17.681 21 15.994 21 14.6 21 12.407 19.476 10.967 17.447 10.88z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M8.788 1.518 15.37 2.98 20.657 1.737C21.598 1.515 22.5 2.23 22.5 3.197V10.882C22.09 10.296 21.581 9.794 21 9.392V3.196L16.125 4.344V8.342C15.601 8.428 15.098 8.573 14.625 8.774V4.35L9.375 3.185V18.898L12.601 19.615C12.864 20.021 13.137 20.404 13.41 20.754Q13.7 21.124 13.995 21.46L8.63 20.27 3.344 21.513C2.402 21.735 1.5 21.02 1.5 20.053V4.973C1.5 4.328 1.913 3.757 2.521 3.552 4.691 2.817 6.051 2.324 8.386 1.539L8.584 1.473zM7.875 3.297C6.093 3.903 4.925 4.322 3.001 4.972L3 4.973V20.053L7.875 18.905z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MapAltIcon
